<script lang="ts">
  import WorkOrderAppointmentTag from "../../../../../../../../../../../../../../_shared/_modules/work-order-appointment-tag"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../../../contract"
  import { workOrderAssignmentAppointmentComparisonDisplay } from "../../../../_shared/_logic/01-assign-work-order-presentation"

  let {
    row,
    draft,
  }: {
    row: WorkOrderAssignmentRow
    draft: AssignWorkOrderDraft
  } = $props()

  const display = $derived(workOrderAssignmentAppointmentComparisonDisplay(row, draft))
</script>

<WorkOrderAppointmentTag
  status={display.status}
  subLabel={display.subLabel}
  fallbackLabel={display.fallbackLabel}
  tooltipContent={display.tooltipContent}
  disabled={row.disabled}
/>
